/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'codeiphone': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M767.153 13.926H257.43c-89.711 0-163.112 73.4-163.112 163.112v672.836c0 89.712 73.4 163.112 163.112 163.112h509.724c89.712 0 163.112-73.4 163.112-163.112V177.038c0-89.711-73.4-163.112-163.112-163.112zM257.43 107.133h509.724c38.448 0 69.906 31.457 69.906 69.905v427.004H187.524V177.038c0-38.448 30.875-69.905 69.905-69.905zM767.153 919.78H257.43c-38.448 0-69.905-31.458-69.905-69.906V696.666h649.535v153.208c0 38.448-31.458 69.906-69.906 69.906z" _fill="#333"/><path pid="1" d="M465.397 813.757a46.603 46.603 0 1093.206 0 46.603 46.603 0 10-93.206 0z" _fill="#333"/>'
  }
})
